import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
// StrictMode 는 개발 모드에서 useEffect 를 두 번 실행해 로컬 확인 시 API 가 중복 호출되어 제외한다.
// 부작용(cleanup 누락 등) 점검이 필요하면 일시적으로 다시 감싸서 확인한다.
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
